import getApiUrl from "../getApiUrl";

export const exportApi = {
  exportCsv: (payload) => getApiUrl.post("/export/csv", payload),
  getProgress: (queueId) => getApiUrl.get(`/export/progress/${queueId}`)
};
